/**
 * Lifecycle hook that is called after instantiation the component.
 * This method is called before ngOnInit.
 */
var OnMount = (function () {
    function OnMount() {
    }
    return OnMount;
}());
export { OnMount };



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/~/ng-dynamic/src/dynamic-html/interfaces.js
// module id = ../../../../ng-dynamic/src/dynamic-html/interfaces.js
// module chunks = 3